module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.2ccec87.woff";